export const getAudioUrl = (bookId, bookName, chapter) => {
    const paddedBookId = bookId.toString().padStart(2, '0'); // e.g., 1 -> 01
    const paddedChapter = chapter.toString().padStart(3, '0'); // e.g., 1 -> 001
    const unpaddedChapter = chapter.toString();
    return `/static/audio/esv/${paddedBookId}${paddedChapter}_${bookName} ${unpaddedChapter}.mp3`;
  };